import Vue from 'vue'
import Router from 'vue-router'

/* 관리자 분야 */
import AdminLogin from '@/components/Admin/Login/AdminLogin'
import AdminMain from '@/components/Admin/Main/AdminMain'
import AdminRollingBannerManagement from '@/components/Admin/MainManagement/AdminRollingBannerManagement'
import AdminRollingBannerManagementAdd from '@/components/Admin/MainManagement/AdminRollingBannerManagementAdd'
import AdminInstockManagement from '@/components/Admin/MainManagement/AdminInstockManagement'
import AdminNfuPickManagement from '@/components/Admin/MainManagement/AdminNfuPickManagement'
import AdminMonthlyBestManagement from '@/components/Admin/MainManagement/AdminMonthlyBestManagement'
import AdminLivingAccManagement from '@/components/Admin/MainManagement/AdminLivingAccManagement'
import AdminStylingManagement from '@/components/Admin/MainManagement/AdminStylingManagement'
import AdminStylingManagementAdd from '@/components/Admin/MainManagement/AdminStylingManagementAdd'
import AdminInstagramManagement from '@/components/Admin/MainManagement/AdminInstagramManagement'
import AdminInstagramManagementAdd from '@/components/Admin/MainManagement/AdminInstagramManagementAdd'
import AdminTopBannerManagement from '@/components/Admin/MainManagement/AdminTopBannerManagement'
import AdminBannerManagement from '@/components/Admin/MainManagement/AdminBannerManagement'
import AdminMenuPermissionManagement from '@/components/Admin/SystemManagement/AdminMenuPermissionManagement'
import AdminMenuPermissionManagementAdd from '@/components/Admin/SystemManagement/AdminMenuPermissionManagementAdd'
import AdminManagement from '@/components/Admin/SystemManagement/AdminManagement'
import AdminManagementAdd from '@/components/Admin/SystemManagement/AdminManagementAdd'
import AdminBrandManagement from '@/components/Admin/ProductManagement/AdminBrandManagement'
import AdminBrandManagementAdd from '@/components/Admin/ProductManagement/AdminBrandManagementAdd'
import AdminProductTypeManagement from '@/components/Admin/ProductManagement/AdminProductTypeManagement'
import AdminProductTypeManagementAdd from '@/components/Admin/ProductManagement/AdminProductTypeManagementAdd'
import AdminProductDivisionOneLevelManagement from '@/components/Admin/ProductManagement/AdminProductDivisionOneLevelManagement'
import AdminProductDivisionOneLevelManagementAdd from '@/components/Admin/ProductManagement/AdminProductDivisionOneLevelManagementAdd'
import AdminProductDivisionTwoLevelManagement from '@/components/Admin/ProductManagement/AdminProductDivisionTwoLevelManagement'
import AdminProductDivisionTwoLevelManagementAdd from '@/components/Admin/ProductManagement/AdminProductDivisionTwoLevelManagementAdd'
import AdminProductManagement from '@/components/Admin/ProductManagement/AdminProductManagement'
import AdminProductManagementAdd from '@/components/Admin/ProductManagement/AdminProductManagementAdd'
import AdminCustomerManagement from '@/components/Admin/CustomerManagement/AdminCustomerManagement'
import AdminCustomerManagementAdd from '@/components/Admin/CustomerManagement/AdminCustomerManagementAdd'
import AdminCouponManagement from '@/components/Admin/CustomerManagement/AdminCouponManagement'
import AdminCouponManagementAdd from '@/components/Admin/CustomerManagement/AdminCouponManagementAdd'
import AdminNewsManagement from '@/components/Admin/MenuManagement/AdminNewsManagement'
import AdminNewsManagementAdd from '@/components/Admin/MenuManagement/AdminNewsManagementAdd'
import AdminOrderManagement from '@/components/Admin/OrderDeliveryManagement/AdminOrderManagement'
import AdminOrderManagementAdd from '@/components/Admin/OrderDeliveryManagement/AdminOrderManagementAdd'
import AdminImmediatePaymentManagement from '@/components/Admin/OrderDeliveryManagement/AdminImmediatePaymentManagement'

/* 홈페이지 분야 */
import Main from '@/components/Homepage/Main/Main'
import Brand from '@/components/Homepage/Brand/Brand'
import BrandDetail from '@/components/Homepage/Brand/BrandDetail'
import Styling from '@/components/Homepage/Styling/Styling'
import StylingDetail from '@/components/Homepage/Styling/StylingDetail'
import Product from '@/components/Homepage/Product/Product'
import News from '@/components/Homepage/News/News'
import NewsDetail from '@/components/Homepage/News/NewsDetail'
import TopBanner from '@/components/Homepage/Banner/TopBanner'
import Company from '@/components/Homepage/Company/Company'
import Login from '@/components/Homepage/Login/Login'
import KaKaoLogin from '@/components/Homepage/Login/KaKaoLogin'
import NaverLogin from '@/components/Homepage/Login/NaverLogin'
import SearchIdPassword from '@/components/Homepage/Login/SearchIdPassword'
import My from '@/components/Homepage/My/My'
import Info from '@/components/Homepage/Info/Info'
import Join from '@/components/Homepage/Join/Join'
import ProductDetail from '@/components/Homepage/Product/ProductDetail'
import CartList from '@/components/Homepage/CartList/CartList'
import Order from '@/components/Homepage/Order/Order'
import OrderImmediate from '@/components/Homepage/Order/OrderImmediate'
import OrderSuccess from '@/components/Homepage/Order/OrderSuccess'
import OrderMobileFail from '@/components/Homepage/Order/OrderMobileFail'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    /* 관리자 분야 */
    {
      path: '/AdminLogin',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/AdminMain',
      name: 'AdminMain',
      component: AdminMain
    },
    {
      path: '/AdminRollingBannerManagement',
      name: 'AdminRollingBannerManagement',
      component: AdminRollingBannerManagement
    },
    {
      path: '/AdminRollingBannerManagementAdd',
      name: 'AdminRollingBannerManagementAdd',
      component: AdminRollingBannerManagementAdd
    },
    {
      path: '/AdminInstockManagement',
      name: 'AdminInstockManagement',
      component: AdminInstockManagement
    },
    {
      path: '/AdminNfuPickManagement',
      name: 'AdminNfuPickManagement',
      component: AdminNfuPickManagement
    },
    {
      path: '/AdminMonthlyBestManagement',
      name: 'AdminMonthlyBestManagement',
      component: AdminMonthlyBestManagement
    },
    {
      path: '/AdminLivingAccManagement',
      name: 'AdminLivingAccManagement',
      component: AdminLivingAccManagement
    },
    {
      path: '/AdminStylingManagement',
      name: 'AdminStylingManagement',
      component: AdminStylingManagement
    },
    {
      path: '/AdminStylingManagementAdd',
      name: 'AdminStylingManagementAdd',
      component: AdminStylingManagementAdd
    },
    {
      path: '/AdminInstagramManagement',
      name: 'AdminInstagramManagement',
      component: AdminInstagramManagement
    },
    {
      path: '/AdminInstagramManagementAdd',
      name: 'AdminInstagramManagementAdd',
      component: AdminInstagramManagementAdd
    },
    {
      path: '/AdminTopBannerManagement',
      name: 'AdminTopBannerManagement',
      component: AdminTopBannerManagement
    },
    {
      path: '/AdminBannerManagement',
      name: 'AdminBannerManagement',
      component: AdminBannerManagement
    },
    {
      path: '/AdminMenuPermissionManagement',
      name: 'AdminMenuPermissionManagement',
      component: AdminMenuPermissionManagement
    },
    {
      path: '/AdminMenuPermissionManagementAdd',
      name: 'AdminMenuPermissionManagementAdd',
      component: AdminMenuPermissionManagementAdd
    },
    {
      path: '/AdminManagement',
      name: 'AdminManagement',
      component: AdminManagement
    },
    {
      path: '/AdminManagementAdd',
      name: 'AdminManagementAdd',
      component: AdminManagementAdd
    },
    {
      path: '/AdminBrandManagement',
      name: 'AdminBrandManagement',
      component: AdminBrandManagement
    },
    {
      path: '/AdminBrandManagementAdd',
      name: 'AdminBrandManagementAdd',
      component: AdminBrandManagementAdd
    },
    {
      path: '/AdminProductTypeManagement',
      name: 'AdminProductTypeManagement',
      component: AdminProductTypeManagement
    },
    {
      path: '/AdminProductTypeManagementAdd',
      name: 'AdminProductTypeManagementAdd',
      component: AdminProductTypeManagementAdd
    },
    {
      path: '/AdminProductDivisionOneLevelManagement',
      name: 'AdminProductDivisionOneLevelManagement',
      component: AdminProductDivisionOneLevelManagement
    },
    {
      path: '/AdminProductDivisionOneLevelManagementAdd',
      name: 'AdminProductDivisionOneLevelManagementAdd',
      component: AdminProductDivisionOneLevelManagementAdd
    },
    {
      path: '/AdminProductDivisionTwoLevelManagement',
      name: 'AdminProductDivisionTwoLevelManagement',
      component: AdminProductDivisionTwoLevelManagement
    },
    {
      path: '/AdminProductDivisionTwoLevelManagementAdd',
      name: 'AdminProductDivisionTwoLevelManagementAdd',
      component: AdminProductDivisionTwoLevelManagementAdd
    },
    {
      path: '/AdminProductManagement',
      name: 'AdminProductManagement',
      component: AdminProductManagement
    },
    {
      path: '/AdminProductManagementAdd',
      name: 'AdminProductManagementAdd',
      component: AdminProductManagementAdd
    },
    {
      path: '/AdminCustomerManagement',
      name: 'AdminCustomerManagement',
      component: AdminCustomerManagement
    },
    {
      path: '/AdminCustomerManagementAdd',
      name: 'AdminCustomerManagementAdd',
      component: AdminCustomerManagementAdd
    },
    {
      path: '/AdminCouponManagement',
      name: 'AdminCouponManagement',
      component: AdminCouponManagement
    },
    {
      path: '/AdminCouponManagementAdd',
      name: 'AdminCouponManagementAdd',
      component: AdminCouponManagementAdd
    },
    {
      path: '/AdminNewsManagement',
      name: 'AdminNewsManagement',
      component: AdminNewsManagement
    },
    {
      path: '/AdminNewsManagementAdd',
      name: 'AdminNewsManagementAdd',
      component: AdminNewsManagementAdd
    },
    {
      path: '/AdminOrderManagement',
      name: 'AdminOrderManagement',
      component: AdminOrderManagement
    },
    {
      path: '/AdminOrderManagementAdd',
      name: 'AdminOrderManagementAdd',
      component: AdminOrderManagementAdd
    },
    {
      path: '/AdminImmediatePaymentManagement',
      name: 'AdminImmediatePaymentManagement',
      component: AdminImmediatePaymentManagement
    },

    /* 홈페이지 분야 */
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/Brand',
      name: 'Brand',
      component: Brand
    },
    {
      path: '/BrandDetail',
      name: 'BrandDetail',
      component: BrandDetail
    },
    {
      path: '/Styling',
      name: 'Styling',
      component: Styling
    },
    {
      path: '/StylingDetail',
      name: 'StylingDetail',
      component: StylingDetail
    },
    {
      path: '/Product',
      name: 'Product',
      component: Product
    },
    {
      path: '/News',
      name: 'News',
      component: News
    },
    {
      path: '/NewsDetail',
      name: 'NewsDetail',
      component: NewsDetail
    },
    {
      path: '/TopBanner',
      name: 'TopBanner',
      component: TopBanner
    },
    {
      path: '/Company',
      name: 'Company',
      component: Company
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/KaKaoLogin',
      name: 'KaKaoLogin',
      component: KaKaoLogin
    },
    {
      path: '/NaverLogin',
      name: 'NaverLogin',
      component: NaverLogin
    },
    {
      path: '/SearchIdPassword',
      name: 'SearchIdPassword',
      component: SearchIdPassword
    },
    {
      path: '/My',
      name: 'My',
      component: My
    },
    {
      path: '/Info',
      name: 'Info',
      component: Info
    },
    {
      path: '/Join',
      name: 'Join',
      component: Join
    },
    {
      path: '/ProductDetail',
      name: 'ProductDetail',
      component: ProductDetail
    },
    {
      path: '/CartList',
      name: 'CartList',
      component: CartList
    },
    {
      path: '/Order',
      name: 'Order',
      component: Order
    },
    {
      path: '/OrderImmediate',
      name: 'OrderImmediate',
      component: OrderImmediate
    },
    {
      path: '/OrderSuccess',
      name: 'OrderSuccess',
      component: OrderSuccess
    },
    {
      path: '/OrderMobileFail',
      name: 'OrderMobileFail',
      component: OrderMobileFail
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js